angular.module('gym.contacts').controller('MemberLoginDetailsModalCtrl', ["$scope", "$rootScope", "$modalInstance", "contact", function($scope, $rootScope, $modalInstance, contact) {
  $scope.contact = contact;
  $scope.gym = $rootScope.gym;
  $scope.loginUrl = `${contact.member_portal_details.login_url}`;
  $scope.submit = function() {
    $scope.isLoading = true;
    return $scope.contact.doPOST({}, 'deliver_member_portal_auth_details').then(function() {
      $scope.isLoading = false;
      return $modalInstance.close();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
